module.exports = __webpack_public_path__ + "static/media/29BDOS12.242840a9.jpg";